import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BuildingConstruction } from '../../../../../../services/types/Calculator';
import { Modal } from '../../../../../../shared/components';
import { handleKeyDown } from '../../Utils/KeyboardHandlers';
import CalculatorSectorContext from '../UrbanInfrastructureTool/CalculatorSectorContext';
import BuildingConstructionDetails from './Details/BuildingConstructionDetails';
import {
  setBuildingNotEstimatedEmissions,
  calculateBuildingNotEstimatedEmissions,
} from '../../Utils/moduleCalculates';

import CalculatorTableWrapper from '../Shared/CalculatorTableWrapper';

interface Props {
  emissionsDevelopmentBuildingConstruction: BuildingConstruction;
  onUpdateEmissionsDevelopmentBuildingConstruction: (
    updatedBuildingConstruction: BuildingConstruction
  ) => void;
}

const EmissionsDevelopmentBuildingConstructionSection: React.FC<Props> = ({
  emissionsDevelopmentBuildingConstruction,
  onUpdateEmissionsDevelopmentBuildingConstruction,
}) => {
  const { t } = useTranslation();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [totalCarbonSum, setTotalCarbonSum] = useState<number | null>(
    emissionsDevelopmentBuildingConstruction.subTotal
  );
  const { measurementSystem } = useContext(CalculatorSectorContext);

  const getTextMeasure = (): string => (measurementSystem.id === 1 ? 'Meters' : 'Feet');

  const handleInputTotalArea = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (value.length > 10) {
      return; // Si excede 10 caracteres, no actualiza el estado.
    }

    // Permitir valores vacíos.
    onUpdateEmissionsDevelopmentBuildingConstruction({
      ...emissionsDevelopmentBuildingConstruction,

      totalArea: value === '' ? null : Number(value),
    });
  };

  useEffect(() => {
    const isEstimated = 1;
    const totalArea = Number(emissionsDevelopmentBuildingConstruction.totalArea);

    if (totalArea && emissionsDevelopmentBuildingConstruction.totalArea) {
      const updatedConstruction = setBuildingNotEstimatedEmissions(
        emissionsDevelopmentBuildingConstruction,
        isEstimated
      );
      const result = calculateBuildingNotEstimatedEmissions(updatedConstruction);

      onUpdateEmissionsDevelopmentBuildingConstruction({
        ...updatedConstruction,
        totalArea,
        isEstimated: false,

        moduleId: 0,
        subTotal: result,
      });
      setTotalCarbonSum(result);
    }

    if (emissionsDevelopmentBuildingConstruction.totalArea === null) {
      onUpdateEmissionsDevelopmentBuildingConstruction({
        ...emissionsDevelopmentBuildingConstruction,
        subTotal: null,
      });
      setTotalCarbonSum(null);
    }
  }, [
    emissionsDevelopmentBuildingConstruction.isEstimated,
    emissionsDevelopmentBuildingConstruction.totalArea,
  ]);

  return (
    <>
      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-2">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Square ') + getTextMeasure()}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            title="Total Area"
            type="number"
            id="totalAreaInput"
            name="totalAreaInput"
            value={
              emissionsDevelopmentBuildingConstruction.totalArea !== null
                ? emissionsDevelopmentBuildingConstruction.totalArea
                : ''
            }
            min="0"
            max={99999999.99}
            maxLength={10}
            className="calculator-input"
            onChange={handleInputTotalArea}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>
      <CalculatorTableWrapper
        totalCarbonSum={totalCarbonSum}
        onShowDetailsModal={() => setShowDetailsModal(true)}
        tableClassName="table--bordered"
        subtotalColSpan={3}
        colGroup={
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '10%' }} />
          </colgroup>
        }
      />
      <Modal
        title={emissionsDevelopmentBuildingConstruction.name}
        visible={showDetailsModal}
        setVisible={() => setShowDetailsModal(false)}
        actions={[{ text: 'Close', action: () => setShowDetailsModal(false) }]}
        customClass="extra_wide-modal"
        onClosed={() => setShowDetailsModal(false)}
      >
        <div className="mb-0 table-responsive">
          <BuildingConstructionDetails
            buildingConstruction={emissionsDevelopmentBuildingConstruction}
          />
        </div>
      </Modal>
    </>
  );
};

export default EmissionsDevelopmentBuildingConstructionSection;
